import _ from "lodash";
import React, { useContext } from "react";
import {
  flatSlotsForLine,
  LINES,
  LineTab,
  LineViewTabsContext,
  slotsForLine,
} from "../context/LineViewTabsContext";
import I18n from "i18n-js";
import { SlotKey } from "../types";
import { LineupContext } from "../context/LineupContext";

interface Props {
  selected: LineTab;
  setSelected(tab: LineTab): void;
  keysWithPicks: SlotKey[];
  markLinesWithMissingPicks: boolean;
}

const showMissingMark = (line: LineTab, keysWithPicks: SlotKey[] ): boolean => {
  const checkThoseSlots = line === 'line1'
    ? flatSlotsForLine[line]
    : _.filter(flatSlotsForLine[line], (sl) => sl !== 'goal' && sl !== 'goalsub'); // don't consider goalies for the other lines
    
  return _.some(
    checkThoseSlots,
    (sl) => !_.includes(keysWithPicks, sl)
  );
}

export const LineTabsInner: React.FC<Props> = ({
  selected,
  setSelected,
  keysWithPicks,
  markLinesWithMissingPicks,
}) => {
  return (
    <div className="neo__lineupTabs">
      <div className="neo__lineupTabs__container">
        {_.map(LINES, (l) => {
          const Inner = (
            <>
              <h4>
                <span>{I18n.t(`lineup.line_${l}`)}</span>
                {markLinesWithMissingPicks && showMissingMark(l, keysWithPicks) &&
                  <span className="neo__lineupTabs__missingSlotsMarking" />}
              </h4>
              <span className="neo__lineupTabs__dots">
                {/* <span key="goal">{_.map(slotsForLine[l].goal, (k) => keysWithPicks.includes(k) ? <strong key={k} /> : <span key={k} />)}</span> */}
                <span key="def">
                  {_.map(slotsForLine[l].def, (k) =>
                    keysWithPicks.includes(k) ? (
                      <strong key={k} />
                    ) : (
                      <span key={k} />
                    )
                  )}
                </span>
                <span key="for">
                  {_.map(slotsForLine[l].for, (k) =>
                    keysWithPicks.includes(k) ? (
                      <strong key={k} />
                    ) : (
                      <span key={k} />
                    )
                  )}
                </span>
              </span>
            </>
          );
          return (
            <div key={l} className="neo__lineupTabs__tab">
              {l === selected ? (
                <span>{Inner}</span>
              ) : (
                <a onClick={() => setSelected(l)}>{Inner}</a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const LineTabs: React.FC = () => {
  const { lineup } = useContext(LineupContext);
  const { selected, setSelected } = useContext(LineViewTabsContext);

  const keysWithPicks = lineup
    ? (Object.keys(lineup.slots).filter(
        (k) => !!lineup.slots[k as SlotKey]?.pick
      ) as SlotKey[])
    : [];

  return (
    <LineTabsInner
      markLinesWithMissingPicks={lineup?.edit_info?.can_edit || false}
      selected={selected}
      setSelected={setSelected}
      keysWithPicks={keysWithPicks}
    />
  );
};
